import React from "react";
import { CommandBarButton, Stack, useDisclosure } from "sprint-common-web";

import { RequestCloudFileFixDialog } from "../../common/components/request-cloud-fix/RequestCloudFileFixDialog";
import { useCloudFileDetails } from "../common/useCloudFileDetails";

export const RequestCloudFileFixButton = (): JSX.Element => {
    const { data: cloudFileDetails } = useCloudFileDetails();

    const { isOpen, onClose, onOpen } = useDisclosure();

    if (!cloudFileDetails) {
        return <></>;
    }

    return (
        <Stack>
            <CommandBarButton
                text="Request fix"
                icon="ProcessMetaTask"
                onClick={onOpen}
                disabled={!cloudFileDetails.fileName}
            />
            <RequestCloudFileFixDialog
                deliveryFileName={cloudFileDetails.fileName}
                filePath={cloudFileDetails.filePath}
                isOpen={isOpen}
                cloudFileId={cloudFileDetails.cloudFileId}
                onClose={onClose}
            />
        </Stack>
    );
};
